//----------------------------------------
// references.js
// Author: @codymarcoux (Studio123)
//----------------------------------------

$('sup').each(function(i, reference) {
  var referenceText = $(reference).text();
  if(stringContainsNumber(referenceText) !== null){
    $(reference).wrapInner('<a href="#references"></a>');
  }
});

function stringContainsNumber(string){
  var pattern = /[0-9]/; 
  return string.match(pattern);
}
